import styled, { css } from 'styled-components'

import { RowFlex } from 'components/common/genericStyles'

export const Avatars = styled.div`
    ${RowFlex}
    position: relative;
    height: 50px;
`
export const AvatarWrapper = styled.div`
    width: 50px;
    height: 100%;

    ${props =>
        props.isLastElem &&
        css`
            position: absolute;
            ${props.rowReverse ? 'left' : 'right'}: 80%;
            border-radius: 50%;
            box-shadow: 0px 0px 5px 2px rgb(0 0 0 / 90%);
        `}
`
